import type {EffectiveLight} from "@/tabletop/visibility/LightGeometry.ts";

export const lightLockKey = (levelId: string, lightId: string) => `${levelId}:${lightId}`;

/** Dungeon lights start locked; encounter lights start unlocked. Toggling reverses that default. */
export function isLightLocked(source: EffectiveLight["source"], key: string,
    toggledLightLocks: ReadonlySet<string>): boolean {
    const toggled = toggledLightLocks.has(key);
    return source === "dungeon" ? !toggled : toggled;
}
